module.exports = __webpack_public_path__ + "img/z.028ada41.png";